import { useAsyncCenter } from '../../hooks/useAsyncCenter';

// We just need a place to call the hook so that it's available as a "pub sub" in the app
export const AsyncCenter = () => {
  useAsyncCenter();

  return null;
};
